import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { BillingSubscription } from '@kawai/shared';
import { fetchBillingSubscriptionByTenant } from '../repositories/billingSubscriptions.js';

/**
 * 単一テナントの billing_subscriptions doc（read 専用）の React Query hook。
 *
 * cache key は `['billing_subscription', tenantId]`。doc id = tenantId のため getDoc 1 回。
 * 明細ページで全件取得（`useBillingSubscriptions`）を避ける。未確定の間は fetch しない。
 */
export function useBillingSubscription(
  tenantId: string,
): UseQueryResult<BillingSubscription | null, Error> {
  return useQuery({
    queryKey: ['billing_subscription', tenantId],
    queryFn: () => fetchBillingSubscriptionByTenant(tenantId),
    enabled: tenantId !== '',
  });
}
